/** What the user picked in the avatar menu. */
export type ThemePreference = "light" | "dark" | "system";

/** What is actually painted; `system` resolves to one of these. */
export type ResolvedTheme = "light" | "dark";

export const THEME_PREFERENCES: readonly ThemePreference[] = [
  "light",
  "dark",
  "system"
];

export const isThemePreference = (value: unknown): value is ThemePreference =>
  typeof value === "string" &&
  (THEME_PREFERENCES as readonly string[]).includes(value);
